import React from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useIsP2IAPage } from '../../compagnon/routers/useIsP2IA'
import { MunchkinCookie } from './munchkin'

export const Metadata: React.FC = () => {
  const [t, i18n] = useTranslation('meta')
  const isP2IA = useIsP2IAPage()

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <meta name="description" content={t('description')} />
        <link
          href={window.location.href.replace('www', '').replace('.html', '')}
          rel="canonical"
        />
        <meta property="og:image" content={t('image')} />
      </Helmet>
      {!isP2IA && <MunchkinCookie />}
    </>
  )
}
